import React from "react";
import { navigate } from "hookrouter";
import cogoToast from "cogo-toast";
import StoryCoverEditor from "./StoryCoverEditor";
import StoryForm from "./StoryForm";
import styles from "./StoryCreate.module.css";
import { useForm } from "react-hook-form";
import { useStory } from "../StoryHooks";
import Loading from "../../Loading/Loading";

const Write = () => {
  const [imageEditor, setImageEditor] = React.useState(null);
  const [redirect, setRedirect] = React.useState("/");

  const { register, handleSubmit, errors, setValue, getValues } = useForm();
  const [setStory, loading] = useStory();

  const submitData = async (data, blob) => {
    var formdata = new FormData();

    Object.keys(data).forEach((key) => {
      if (Array.isArray(data[key])) {
        data[key].forEach((val) => {
          formdata.append(key + "[]", val);
        });
      } else {
        formdata.append(key, data[key]);
      }
    });

    formdata.append("coverImage", blob);
    const resp = await setStory(formdata);
    console.log(resp);
    if (resp.success || resp.status) {
      cogoToast.success("Success");
      const newStoryId = resp.story._id;
      if (redirect === "episode") {
        navigate(`/episode/new/${newStoryId}`);
      } else {
        navigate(`/story/${newStoryId}`);
      }
    } else {
      if (resp.message) {
        cogoToast.error(resp.message);
      } else {
        cogoToast.error("Something Went Wrong");
      }
    }
  };

  console.log(getValues());

  const onSubmit = (data) => {
    if (imageEditor && imageEditor.current) {
      imageEditor.current.getImage().toBlob((blob) => submitData(data, blob));
    } else {
      cogoToast.error("Please add an image");
    }
  };

  return (
    <div className={styles.write}>
      {loading && <Loading top={true} />}

      <form className={styles.main} onSubmit={handleSubmit(onSubmit)}>
        <StoryCoverEditor
          imageEditor={imageEditor}
          setImageEditor={setImageEditor}
        />
        <div className={styles.container}>
          <div className={styles.story}>
            <h4>Story Details</h4>
            <div className={styles.divider}></div>
            <StoryForm
              register={register}
              setValue={setValue}
              errors={errors}
              onSubmit={onSubmit}
              setRedirect={setRedirect}
            />
          </div>
        </div>
      </form>
    </div>
  );
};

export default Write;
